import { i18nTranslate } from 'src/utils'

/**
 * Checkout accordion/step path constants
 * Use these instead of hardcoded strings for maintainability
 */
export const CHECKOUT_PATHS = {
  CART: 'cart',
  SIGNIN: 'signin',
  SHIPPING: 'shipping',
  PICKUP: 'pickup',
  SHIPPING_METHODS: 'shippingMethods',
  LOYALTY: 'loyalty',
  PAYMENT: 'payment',
  REVIEW: 'review',
}

function getTabKeys() {
  return [
    {
      index: 0,
      key: 'cart',
      label: i18nTranslate('checkout.cartTitle', 'Cart'),
      dataTestId: 'qa-cart-title',
    },
    {
      index: 1,
      key: 'signin',
      label: i18nTranslate('checkout.signinTitle', 'Sign In'),
      dataTestId: 'qa-signin-title',
    },
    {
      index: 2,
      key: 'shipping',
      label: i18nTranslate('checkout.shippingTitle', 'Shipping'),
      dataTestId: 'qa-ship-title',
    },
    {
      index: 3,
      key: 'pickup',
      label: i18nTranslate('checkout.pickupPerson', 'Pickup Person Name'),
      dataTestId: 'qa-submit-title',
    },
    {
      index: 4,
      key: 'shippingMethods',
      label: i18nTranslate('checkout.shippingMethodTitle', 'Shipping Method'),
      dataTestId: 'qa-shipping-method-title',
    },
    {
      index: 5,
      key: 'loyalty',
      label: i18nTranslate('nuskinEnjoyRewards.title', 'Nu Skin Rewards', {
        nameSpace: 'ssr-resource',
      }),
      dataTestId: 'qa-shipping-method-title',
    },
    {
      index: 6,
      key: 'payment',
      label: i18nTranslate(
        'checkout.paymentTitle',
        'Billing and Payment Method'
      ),
      dataTestId: 'qa-pay-title',
    },
    {
      index: 7,
      key: 'review',
      label: i18nTranslate('checkout.reviewTitle', 'Review and Submit Order'),
      dataTestId: 'qa-submit-title',
    },
  ]
}

const flowPaths = [
  'cart',
  'signin',
  'shipping',
  'pickup',
  'shippingMethods',
  'loyalty',
  'payment',
  'review',
]

const flowSkipPaths = {
  registeredUser: ['signin'],
  pickUpOnly: ['shipping', 'shippingMethods'],
  shipmentOnly: ['pickup'],
  guestUser: ['loyalty'],
  b2b: ['cart'],
  itemLevelAddress: ['shippingMethods'],
}

export const loyaltyRewardsFormData = {
  dataTestId: 'loyalty-rewards',
  offTitle: i18nTranslate(
    'account.loyaltyOffTitle',
    'Would you like to Opt In to Nu Skin Rewards program?'
  ),
  onTitle: i18nTranslate(
    'account.loyaltyOnTitle',
    'You have now Opted in to Nu Skin Rewards program!'
  ),
  optOutTxt: i18nTranslate(
    'account.loyaltyoptOutTxt',
    'You are opted out of the Nu Skin Rewards Program!'
  ),
  optInTxt: i18nTranslate(
    'account.loyaltyoptOffTxt',
    'Please move to My Profile/Rewards & Credits page if you would like to Opt Out.'
  ),
  brandAffiliateUserTxt: i18nTranslate(
    'account.loyaltybrandAffiliateUserTxt',
    'Nu Skin Rewards Program is exclusively for Retail Customers and Members!'
  ),
  buyerUserTxt: i18nTranslate(
    'account.loyaltybuyerUserTxtTxt',
    'You are still not opted in to the Nu Skin Rewards Program. You will automatically be opted in when your Primary User opts in.'
  ),
}

export { getTabKeys, flowPaths, flowSkipPaths }
